import { apiClient } from './authService';

const rewardService = {
  // Get all rewards with optional filters
  getAllRewards: async (customerId = null, isUsed = null) => {
    try {
      let url = 'customers/rewards/';
      const params = new URLSearchParams();
      
      if (customerId) {
        params.append('customer_id', customerId);
      }
      
      if (isUsed !== null) {
        params.append('is_used', isUsed);
      }
      
      if (params.toString()) {
        url += `?${params.toString()}`;
      }
      
      const response = await apiClient.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching rewards:', error);
      throw error;
    }
  },

  // Get reward summary for a customer
  getCustomerSummary: async (customerId) => {
    try {
      const response = await apiClient.get(`customers/rewards/customer_summary/?customer_id=${customerId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching customer reward summary:', error);
      throw error;
    }
  },

  // Get a specific reward
  getReward: async (id) => {
    try {
      const response = await apiClient.get(`customers/rewards/${id}/`);
      return response.data;
    } catch (error) {
      console.error('Error fetching reward:', error);
      throw error;
    }
  },

  // Create a new reward
  createReward: async (rewardData) => {
    try {
      const response = await apiClient.post('customers/rewards/', rewardData);
      return response.data;
    } catch (error) {
      console.error('Error creating reward:', error);
      throw error;
    }
  },

  // Use a reward (mark as used)
  useReward: async (id) => {
    try {
      const response = await apiClient.post(`customers/rewards/${id}/use_reward/`);
      return response.data;
    } catch (error) {
      console.error('Error using reward:', error);
      throw error;
    }
  },

  // Update a reward
  updateReward: async (id, rewardData) => {
    try {
      const response = await apiClient.put(`customers/rewards/${id}/`, rewardData);
      return response.data;
    } catch (error) {
      console.error('Error updating reward:', error);
      throw error;
    }
  },

  // Delete a reward
  deleteReward: async (id) => {
    try {
      const response = await apiClient.delete(`customers/rewards/${id}/`);
      return response.data;
    } catch (error) {
      console.error('Error deleting reward:', error);
      throw error;
    }
  }
};

export default rewardService;
